export default __webpack_public_path__ + "static/media/admin-ols-account.b47f5c26.jpg";